import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ListBase } from 'src/app/components/core/_infrastructure/classes/listBase';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { Table } from 'primeng/table';
import { EnumIdsTcTipoSolicitudCam, EnumTcEstadoUnidadInspeccion } from '../../../types/enum';
import { EnumCodigosTwTcAcciones } from 'src/app/components/_importacion/solicitudes/types/enum';
import { UserDataViewModel } from '../../../buscadores/solicitudes/buscador-solicitud-cam.types';
import { RecintoUnidadInspeccionItemViewModel } from '../../../buscadores/unidades-inspeccion/buscador-unidad-inspeccion.types';

@Component({
    selector: 'app-unidad-inspeccion-list',
    templateUrl: './unidad-inspeccion-list.component.html',
    styleUrls: ['./unidad-inspeccion-list.component.scss'],
})
export class UnidadInspeccionListComponent extends ListBase implements OnInit, OnChanges {
    @Input() result: RecintoUnidadInspeccionItemViewModel[];
    @Input() title: { plural: string; singular: string };
    @Input() readonly: boolean;
    @Input() userData: UserDataViewModel;
    @Output() view = new EventEmitter<RecintoUnidadInspeccionItemViewModel>();
    @Output() delete = new EventEmitter<number>();

    @ViewChild('tableSearch') turboTable: Table;

    cols: any[];
    ID_TIPO_PARCELA = EnumIdsTcTipoSolicitudCam.ID_PARCELA;
    ID_TIPO_INVERNADERO = EnumIdsTcTipoSolicitudCam.ID_INVERNADERO;
    ID_TIPO_ALMACEN = EnumIdsTcTipoSolicitudCam.ID_CONFECCION;
    ID_TIPO_EMP_DESHIDRATADORA = EnumIdsTcTipoSolicitudCam.ID_EMPRESA_DESHIDRATACION;
    SIN_ASIGNAR = EnumTcEstadoUnidadInspeccion.SIN_ASIGNAR;

    constructor(protected notificacionService: NotificationService) {
        super(notificacionService);
    }

    ngOnInit() {
        this.initCols();
        this.loading = false;
    }

    private initCols(): void {
        this.cols = [
            { field: 'ExpandLink', header: '', reduce: true },
            { field: 'Link', header: '', reduce: true },
            { field: 'Image', header: '', reduce: true },
            { field: 'IdUi', header: 'Id', display: 'none' },
            { field: 'CodigoUhc', header: 'Cod. Ud. Insp.' },
            { field: 'Campania', header: 'Campaña' },
            { field: 'Periodo', header: 'Periodo' },
            { field: 'TipoSolicitud', header: 'Tipo Recinto' },
            { field: 'DescripcionComunidad', header: 'Com. Aut.' },
            { field: 'EntidadAuditora', header: 'Entidad Auditora' },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.result?.currentValue) {
            this.result = [...changes.result.currentValue];
            this.loading = false;
            setTimeout(() => {
                if (this.turboTable) {
                    this.turboTable.first = 1 * this.result?.length;
                }
            }, 100);
        }
    }

    onDelete(item: RecintoUnidadInspeccionItemViewModel): void {
        if (!item.Id) {
            return;
        }
        this.delete.emit(item?.Id);
    }

    onView(item: RecintoUnidadInspeccionItemViewModel): void {
        this.view.emit(item);
    }

    /***
     * Este método indica si se puede borrar la vinculación entre el recinto PI y la Ud. de inspección.
     * No se permite eliminar UIs de tipo Almacén o Emp. Deshidratación
     * @param item RecintoUnidadInspeccionItemViewModel
     * @return boolean
     */
    hasDeleteAccess(item: RecintoUnidadInspeccionItemViewModel): boolean {
        if (!item.PeriodoEnPlazoVigente) {
            return false;
        }
        const hasAccess =
            this.userData?.loggedInUser?.getAction(EnumCodigosTwTcAcciones.REMOVE_RECINTO_UD_INSPECCION, item.IdEstadoUi, item.IdTipoSolicitudCam).Editable ||
            false;
        return hasAccess;
    }

    /***
     * Este método indica si se puede visualizar el detalle del recinto PIA.
     * @param item RecintoUnidadInspeccionItemViewModel
     * @return boolean
     */
    hasViewAccess(item: RecintoUnidadInspeccionItemViewModel): boolean {
        const hasAccess = this.userData?.loggedInUser?.getAction(EnumCodigosTwTcAcciones.VIEW_UD_INSPECCION, item.IdEstadoUi).Visible || false;
        return hasAccess;
    }
}
